/**
 * Shimmer placeholder shown while data loads (instead of a blank screen).
 *
 *   <Skeleton w="60%" h={12} />          // a line
 *   <Skeleton circle size={40} />        // an avatar
 *   <SkeletonRows count={5} />           // a few list rows
 */
export default function Skeleton({ w = "100%", h = 12, radius = 6, circle = false, size = 40, style }) {
  const shape = circle
    ? { width: size, height: size, borderRadius: "50%" }
    : { width: w, height: h, borderRadius: radius };
  return <div className="skeleton" style={{ ...shape, ...(style || {}) }} />;
}

/** Convenience: a stack of skeleton "rows" for list/table loading states. */
export function SkeletonRows({ count = 5, gap = 10 }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap }}>
      {Array.from({ length: count }).map((_, i) => (
        <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <Skeleton circle size={36} />
          <div style={{ flex: 1 }}>
            <Skeleton w="55%" h={12} style={{ marginBottom: 8 }} />
            <Skeleton w="35%" h={10} />
          </div>
        </div>
      ))}
    </div>
  );
}
